<template>
    <div class="devices-list__block" v-if="deviceData" @click="openChart">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title w-100">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <div class="main-text mt-3" v-if="deviceData.state && deviceData.online">
            <span v-if="deviceData.state.humidity">Влажность: {{ (deviceData.state.humidity).toFixed(1) }}%</span>
        </div>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}
            </div>
        </v-flex>
    </div>
</template>

<script>
export default {
    name: "HumidityDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openChart() {
            if (!this.deviceData.is_action) {
                this.$router.push({
                    name: 'chartPage',
                    query: {device: this.deviceData.uid, type: "hum"}
                });
            }
        },
    },
}
</script>